import React, {useState} from 'react'
import "./VideoGallery.style.css";
import VideoModal from '../../Helpers/VideoModal.component';
import VideoItem from "./VideoItem.component";
import WebData from "../../Helpers/WebData";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

function VideoGallery() {

    // Swiper Pagination config
    SwiperCore.use([Pagination, Autoplay]);

    // VideoItem click action
    const [videoModal, setVideoModal] = useState({visible: false, url: ""});
    const setVideoModalStatus = (visible = false, url="") => setVideoModal({visible: visible, url: url});

    // Show Background image
    const [contentOpacity, setContentOpacity] = useState(1);
    const showBackground = () => {
        setContentOpacity(0);
        setTimeout(() => {
           setContentOpacity(1); 
        }, 3000);
    }

    const preventClickThrough = (e) => {
        if(e.stopPropagation){ e.stopPropagation() }
        if(e.nativeEvent && e.nativeEvent.stopImmediatePropagation)
        {
            e.nativeEvent.stopImmediatePropagation()
        }
    }

    return (
        <>
            <section className="video-gallery" id="video-gallery" onClick={showBackground}>
                <div className="gallery-background"></div>
                <div style={{opacity: contentOpacity}} className="h-100 w-100 content">
                    <div  onClick={preventClickThrough} className="global-heading text-center gallery-title">
                        <strong>Video Gallery</strong>
                    </div>
                    <p  onClick={preventClickThrough} className="gallery-desc">
                        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tenetur atque in perspiciatis sapiente odit molestiae.
                    </p>
                    <div className="gallery-videos" onClick={preventClickThrough}>
                        <Swiper
                            slidesPerView={'auto'}
                            autoplay={{
                                "delay": 3000,
                            }}
                            pagination={{clickable: true}}
                            loop={true}
                        >
                        {
                            WebData.videoGallery.map((item, index) => {
                                return <SwiperSlide key={index}>
                                    <VideoItem title={item.videoDesc} thumbnail={item.videoThumbnail} url={item.videoUrl} onPlay={() => setVideoModalStatus(true, item.videoUrl)} />
                                </SwiperSlide>
                            })
                        }
                        </Swiper>
                    </div>
                </div>
            </section>
            {videoModal.visible? <VideoModal url={videoModal.url} onClose={() => setVideoModalStatus(false)}/>: ""}
        </>
    )
}

export default VideoGallery
